export default "__VITE_ASSET__0$ljTyy9__"